'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { EDIT_FORBIDDEN, guardExport } from '@/contexts/pipeline-v2/edits/guardAction.server';

export async function startVideoExport(
  bookId: string,
  storyId: string,
  audioStoryId?: string,
  /** 'vertical' (default, 1080×1920 for phones) or the old 'horizontal' film. */
  orientation?: 'vertical' | 'horizontal',
): Promise<ActionResult<{ jobId: string | null }>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    // stale pages / audio: «сначала обновите»
    const stale = await guardExport({ storyId: storyId, familyId, kind: 'video' });
    if (stale) return { success: false, error: stale.message, code: EDIT_FORBIDDEN };

    const { MediaExportService } = await import('@/contexts/media/export/MediaExportService');

    const result = await MediaExportService.startVideoExport({
      bookId,
      familyId,
      storyId,
      audioStoryId,
      ...(orientation ? { orientation } : {}),
    });

    if (!result.success) {
      return { success: false, error: result.error || 'EXPORT_FAILED' };
    }

    return {
      success: true,
      data: { jobId: result.jobId || null },
    };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('startVideoExport', e) };
  }
}
